module.exports = "//d274d294w9cx2v.cloudfront.net/8274fc98c1497985b3f68aa133d3ebba9d0c88d3/images/cashRegistryDefaultSmall.webp";